import { Box, Stack } from "@mui/system";
import BLDWebsiteUserCard from "./BLDWebsiteUserCard";

const BLDWebsiteUser = () => {
  return (
    <>
      <Box>
        <Stack spacing={2}>
          <BLDWebsiteUserCard
            date="13/12/2025"
            Spent="$50,701"
            cpc="$48"
            clickOut="939"
            ClickIn="1,050"
            ftdBR="102"
            ftdNG="47"
            ftdPercentage="46%"
            ftdColor="error"
            cvrPercentage="10%"
            cvrColor="warning" 
            qftd="92"
          />
          <BLDWebsiteUserCard
            date="12/12/2025"
            Spent="$56,791"
            cpc="$48"
            clickOut="1,069"
            ClickIn="1,191"
            ftdBR="169"
            ftdNG="168"
            ftdPercentage="99%"
            ftdColor="success"
            cvrPercentage="14%"
            cvrColor="warning"
            qftd="152"
          />
          <BLDWebsiteUserCard
            date="11/12/2025"
            Spent="$33,822"
            cpc="$45"
            clickOut="704"
            ClickIn="759"
            ftdBR="113"
            ftdNG="112"
            ftdPercentage="99%"
            ftdColor="success"
            cvrPercentage="15%"
            cvrColor="warning"
            qftd="103"
          />
        </Stack>
      </Box>
    </>
  );
};

export default BLDWebsiteUser;
